import { DOCUMENT, registerLocaleData } from '@angular/common';
import localeEnCa from '@angular/common/locales/en-CA';
import localeFrCa from '@angular/common/locales/fr-CA';
import { AfterContentInit, ChangeDetectionStrategy, Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { LoginStateFacade } from '@rci/self-serve-fido/core/fido-login-state/login-state.facade';
import { StateService } from '@rci/state-service';
import { WindowService } from '@rogers/cdk/common/services';
import { LoaderService } from '@rogers/cdk/loader';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { ViewContainerRefService } from './shared/view-container-ref/view-container-ref.service';
import { TranslateService } from '@ngx-translate/core';
import { filter, take } from 'rxjs/operators';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@UntilDestroy()
@Component({
  selector: 'ss-root', // eslint-disable-line @angular-eslint/component-selector
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterContentInit, OnInit {
  isLoading$: Observable<boolean>;
  readonly isLoggedIn$: Observable<boolean>;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    windowService: WindowService,
    loginStateFacade: LoginStateFacade,
    private readonly loaderService: LoaderService,
    private readonly stateService: StateService,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly viewContainerRefService: ViewContainerRefService,
    private readonly translateService: TranslateService,
    private readonly liveAnnouncer: LiveAnnouncer,
  ) {
    registerLocaleData(localeEnCa, 'en');
    registerLocaleData(localeFrCa, 'fr');
    if (
      typeof windowService.windowRef().QSI !== 'undefined' &&
      typeof windowService.windowRef().QSI.API !== 'undefined'
    ) {
      windowService.windowRef().QSI.API.unload();
    }
    this.isLoggedIn$ = loginStateFacade.isLoggedIn$;
  }

  get hasGlobalHeaderFooter() {
    return this.stateService.hasGlobalHeaderFooter;
  }

  ngAfterContentInit(): void {
    // store parent container ref for children to use to launch Modal service.
    this.viewContainerRefService.viewContainerRef = this.viewContainerRef;
  }

  ngOnInit(): void {
    this.isLoading$ = this.loaderService.isLoading.asObservable();
    this.stateService.language$.pipe(untilDestroyed(this)).subscribe(lang => {
      this.document.querySelector('html').setAttribute('lang', lang);
    });
    const pageLoadedTranslationMessage = 'loader.loaded';
    this.translateService
      .get(pageLoadedTranslationMessage)
      .pipe(
        filter(msg => msg !== pageLoadedTranslationMessage),
        take(1),
      )
      .subscribe(pageLoadedMessage => {
        this.liveAnnouncer.announce(pageLoadedMessage, 'polite');
      });
  }
}
